import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  getFilterAttrs,
  saveSelectedFilterAttrs,
} from 'actions/packageOrderList';

const {
  getFilterAttributes,
} = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/pages/oms/PackageOrderList/printSettings/filters`);

let _content = null;

const PrintSettingsButton = ({
  url,
  getFilterAttrs,
  filterAttrs,
  saveSelectedFilterAttrs,
  selectedFilterAttrs: selectedFilters,
}) => {
  const [saved, setSaved] = useState(false);
  const [modalReady, setModalReady] = useState(false);

  useEffect(() => {
    saveSelectedFilterAttrs(selectedFilterAttrs);
  }, []);

  const [selectedFilterAttrs, setSelectedFilterAttrs] = useState(
    getFilterAttributes()
  );

  const openFiltersModal = () => {
    getFilterAttributes();
    setModalReady(true);
  };

  const savePrintSettings = () => {
    saveSelectedFilterAttrs(selectedFilterAttrs);
    localStorage.setItem(
      'selectedFilterAttrsLS',
      JSON.stringify(selectedFilterAttrs)
    );
    setSaved(true);
  };

  const handleCheckboxChange = (e, key) => {
    const { name, checked } = e.target;
    if (checked) {
      setSelectedFilterAttrs([
        ...selectedFilterAttrs,
        { key, label: name, checked },
      ]);
    } else {
      setSelectedFilterAttrs(
        selectedFilterAttrs.filter((filter) => filter.label !== name)
      );
    }
  };

  const filterAttributes = getFilterAttributes().filter((filter) =>
    Boolean(filter.label)
  );

  return (
    _content &&
    _content({
      url,
      getFilterAttrs,
      filterAttrs,
      saveSelectedFilterAttrs,
      saved,
      setSaved,
      modalReady,
      setModalReady,
      selectedFilterAttrs,
      setSelectedFilterAttrs,
      filterAttributes,
      openFiltersModal,
      savePrintSettings,
      handleCheckboxChange,
    })
  );
};

const mapStateToProps = (state) => ({
  filterAttrs: state.packageOrderList.filterAttrs.results,
  selectedFilterAttrs: state.packageOrderList.selectedFilterAttrs,
});

const mapDispatchToProps = {
  getFilterAttrs,
  saveSelectedFilterAttrs,
};

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(PrintSettingsButton);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/oms/PackageOrderList/printSettings/tfs/index.js